import { ReactElement } from 'react';
import Services from '~/ui/components/common/Services';
import { productServicesMock } from '~/ui/components/common/Services/servicesMock';

const ProductExtraContent = (): ReactElement => (
  <div>
    <Services items={productServicesMock} />
  </div>
);

export default ProductExtraContent;
